import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { WizardComponent } from "./wizard.component";

@NgModule({
    declarations: [WizardComponent],
    imports: [CommonModule, FormsModule],
})
export class WizardsModule {}
